import React, {Component, PropTypes } from 'react'
import {connect} from 'react-redux'
import { bindActionCreators } from 'redux'
import ChatBlock from '../components/Chat/ChatBlock'
import $ from 'jquery'
import {api, host} from '../config.js'
import classnames from 'classnames'
const signalR = require("@aspnet/signalr");
import cookie from 'react-cookie'

import CSSModules from 'react-css-modules'
import styles from './chat.css'

import {
  fetchChat,
  fetchChats,
  closeChat,
  addToChat,
  answerToChat,
  answeredChat,
  waitingFromChat,
  setTypeId,
  concatPrivateChatAction,
  concatTeamChatAction,
  concatPublicChatAction,
  clearRenderChat,
  setUnReadComments,
  changeChatComments,
  renderPublicChatAction,
  renderPrivateChatAction,
  renderTeamChatAction,
  changeChatType,
  changeStatusChatAction,
  setUnReadMsgs,
  PUBLIC_CHAT_ID, PRIVATE_CHAT_ID, TEAM_CHAT_ID
} from '../actions'
/**
 *  Компонент Chat
 *  Используется для блока Чат
 *
 */
export class Chat extends Component {
  /**
   * @memberof Chat
   * @prop {object} propTypes - the props that are passed to this component
   * @prop {func} propTypes.closeAdminChat Закрытие админского чата
   * @prop {func} propTypes.closeChat Закрыть чат
   * @prop {func} propTypes.answeredChat Посылает ответ
   * @prop {func} propTypes.addToChat Добавить в чат админа
   * @prop {func} propTypes.fetchChat Получение данных для чата
   * @prop {func} propTypes.changeChatType Сменить тип чата
   * @prop {number} propTypes.chatType Тип чата
   * @prop {number} propTypes.chatTypeId Тип чата числовой
   *
   * */
  static propTypes = {
    closeAdminChat: PropTypes.func,
    closeChat: PropTypes.func.isRequired,
    answeredChat: PropTypes.func.isRequired,
    addToChat: PropTypes.func.isRequired,
    fetchChat: PropTypes.func.isRequired,
    changeChatType: PropTypes.func.isRequired,
    chatType: PropTypes.number,
    chatTypeId: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      isForwarding: false,
      miniChatOpen: false,
      miniChatSmall: true,
      unReadTeamChat:0,
      unReadPrivatChat:0,
      unReadPublicChat:0,
      chatType:2
    }
  }
  toggleMiniChatSmall(bool){
    this.setState({
      miniChatSmall: !this.state.miniChatSmall
    })

    if(this.state.miniChatSmall){
      cookie.save('miniChatSmall', '0', {path: '/', maxAge: 60 * 60 * 24 * 365 * 10})
    } else {
      cookie.save('miniChatSmall', '1', {path: '/', maxAge: 60 * 60 * 24 * 365 * 10})
    }
  }
  checkMessageLength(e) {
    this.setState({
      isMessageValid: e.target && e.target.value.length
    })
  }
  closeChat() {
    const {closeChat, closeAdminChat} = this.props

    if (this.state.isForwarding) {
      this.setState({isForwarding: false})
    }
    closeAdminChat()
  }
  waiting(idGroup) {
    const {
      waitingFromChat
    } = this.props
    waitingFromChat(idGroup)
  }
  answered(id) {
    const { answeredChat, dispatch } = this.props
    answeredChat(id)
      .then(() => dispatch({ type: 'UPDATE_CHATS', updateChats: true }))
    this.closeChat()
  }

  sendMessage(text) {
    const {
      id,
      type,
      typeId,
      groupId,
      chatType,
      chatTypeId,
      admin,
      addToChat,
      answerToChat,
      fetchChat,
      changeStatusChatAction
    } = this.props

    const {
      isForwarding
    } = this.state

    if(!text.length) return
    if (isForwarding) {
      addToChat(chatType, chatTypeId, text)
    } else {
      if (admin) {
        if (chatType === PRIVATE_CHAT_ID) {
          this.concatChat('privateChats', text)
          changeStatusChatAction(groupId)
          answerToChat(groupId, text, chatType, chatTypeId)
            .then(() => fetchChat(PRIVATE_CHAT_ID, chatTypeId))

        }
        if (chatType === PUBLIC_CHAT_ID) {
          this.concatChat('commonChats', text)
          answerToChat(groupId, text, chatType, chatTypeId)
            .then(() => fetchChat(PUBLIC_CHAT_ID, chatTypeId))
        }
      } else {
        if (chatType === PUBLIC_CHAT_ID) {
          answerToChat(id, text, PUBLIC_CHAT_ID, typeId)
          this.concatChat('commonChats', text)
        }
        if (chatType === PRIVATE_CHAT_ID) {
          answerToChat(id, text, PRIVATE_CHAT_ID)
          this.concatChat('privateChats', text)
        }
        if (chatType === TEAM_CHAT_ID) {
          answerToChat(id, text, TEAM_CHAT_ID)
          this.concatChat('teamChats', text)
        }
      }
    }
  }

  concatChat(chatType, text) {
    const { userId,
            user,
            renderPrivateChat = [],
            renderPublicChat = [],
            renderTeamChat = [],
            concatPrivateChatAction,
            concatTeamChatAction,
            concatPublicChatAction
          }
            = this.props
    if(chatType === 'privateChats'){
      let chats = renderPrivateChat.concat({
        date: '2017-00-00T00:00:00.0219899+03:00',
        text: text,
        id:+new Date(),
        isRead: true,
        userInfo: {
          id: userId,
          firstName: user.firstName,
          lastName: user.lastName,
          photo: user.photo
        }
      })
      concatPrivateChatAction(chats)
    }
    if(chatType === 'teamChats'){
      let chats = renderTeamChat.concat({
        date: '2017-00-00T00:00:00.0219899+03:00',
        text: text,
        id:+new Date(),
        userInfo: {
          id: userId,
          firstName: user.firstName,
          lastName: user.lastName,
          photo: user.photo
        }
      })
      concatTeamChatAction(chats)
    }

    if(chatType === 'teamChats'){
      let chats = renderTeamChat.concat({
        date: '2017-00-00T00:00:00.0219899+03:00',
        text: text,
        isRead: true,
        id:+new Date(),
        userInfo: {
          id: userId,
          firstName: user.firstName,
          lastName: user.lastName,
          photo: user.photo
        }
      })
      concatTeamChatAction(chats)
    }

    if(chatType === 'commonChats'){
      let chats = renderPublicChat.concat({
        date: '2017-00-00T00:00:00.0219899+03:00',
        text: text,
        isRead: true,
        id:+new Date(),
        userInfo: {
          id: userId,
          firstName: user.firstName,
          lastName: user.lastName,
          photo: user.photo
        }
      })
      concatPublicChatAction(chats)
    }

    setTimeout(() => {
      this.scrollTop()
    }, 10)
  }

  toggleForwarding() {
    this.setState({
      isForwarding: !this.state.isForwarding
    })
  }


  componentWillMount() {
    const {
      fetchChat,
      admin,
      publicChats,
      privateChats,
      //taskDay,
      teamChats,
      setTypeId
    } = this.props

    const unReadPublicChat = publicChats.unreadCount ? publicChats.unreadCount : 0
    const unReadPrivateChat = privateChats.unreadCount ? privateChats.unreadCount : 0
    const unReadTeamChat = teamChats.unreadCount ? teamChats.unreadCount : 0

    this.setState({
      unReadPublicChat: unReadPublicChat,
      unReadPrivateChat: unReadPrivateChat,
      unReadTeamChat: unReadTeamChat
    })
    if (!admin) {
      // setTypeId(taskDay.id)
      if(!publicChats.comments || !publicChats.comments.length) {
        fetchChat(PUBLIC_CHAT_ID, null)
      }
      if(!privateChats.comments || !privateChats.comments.length) {
        fetchChat(PRIVATE_CHAT_ID, null)
      }
      if(!teamChats.comments || !teamChats.comments.length) {
        fetchChat(TEAM_CHAT_ID, null)
      }
    }
  }
  componentWillUnmount(){
    //this.connection.stop()
  }
  componentWillReceiveProps(nextProps) {

    const { renderPublicChatAction, renderTeamChatAction, fetchChat, renderPrivateChatAction, chatType, typeId, changeChatType } = this.props
    if(nextProps.publicChats.unreadCount !== this.props.publicChats.unreadCount){
      this.setState({
        unReadPublicChat: nextProps.publicChats.unreadCount
      })
      this.props.setUnReadMsgs(nextProps.publicChats.unreadCount + this.state.unReadPrivateChat+ this.state.unReadTeamChat)
    }
    if(nextProps.privateChats.unreadCount !== this.props.privateChats.unreadCount){
      this.setState({
        unReadPrivateChat: nextProps.privateChats.unreadCount
      })
      this.props.setUnReadMsgs(this.state.unReadPublicChat + nextProps.privateChats.unreadCount+ this.state.unReadTeamChat)
    }
    if(nextProps.teamChats.unreadCount !== this.props.teamChats.unreadCount){
      this.setState({
        unReadTeamChat: nextProps.teamChats.unreadCount
      })
      this.props.setUnReadMsgs(this.state.unReadPublicChat + this.state.unReadPrivateChat+ nextProps.teamChats.unreadCount)
    }

    if (nextProps.isFetchingChat === 0 && (nextProps.isFetchingChat !== this.props.isFetchingChat)) {
      setTimeout(() => {
        this.scrollTop()
      }, 10)

      if(!nextProps.isFetching){
        if (chatType === PUBLIC_CHAT_ID) {
          renderPublicChatAction(nextProps.publicChats.comments)
        }

        if (chatType === PRIVATE_CHAT_ID) {
          renderPrivateChatAction(nextProps.privateChats.comments)
        }
        if (chatType === TEAM_CHAT_ID) {
          renderTeamChatAction(nextProps.teamChats.comments)
        }
        if (chatType === TEAM_CHAT_ID) {
          renderTeamChatAction(nextProps.teamChats)
        }
      }
    }
  }
  listenToReadNewMessage(chat, newMessage){
    const {
      privateChats,
      changeChatComments,
      setUnReadComments,
      teamChats,
      publicChats
    } = this.props
    const chatSetRead = () => {
      if(this.connection){
        const {userId, typeId, chatType} =this.props;
        this.connection.invoke('ChatSetRead', userId, chatType, typeId);
        newMessage.style.display = 'none';
        chat.removeEventListener('scroll', scrollHandler);
        if(chatType === 1){
          const comments = publicChats.comments.map(item => {
            if(!item.isRead){
              item.isRead = true
            }
            return item;
          })
          changeChatComments('publicChats', comments)
          setUnReadComments('publicChats', 0)
        }
        if(chatType === 2){
          const comments = privateChats.comments.map(item => {
            if(!item.isRead){
              item.isRead = true
            }
            return item;
          })
          changeChatComments('privateChats', comments)
          setUnReadComments('privateChats', 0)
        }
        if(chatType === 7){
          const comments = teamChats.comments.map(item => {
            if(!item.isRead){
              item.isRead = true
            }
            return item;
          })
          changeChatComments('teamChats', comments)
          setUnReadComments('teamChats', 0)
        }
      }
    }
    const scrollHandler = () => {
        if(chat.children[0].offsetHeight){
          if(chat.children[0].offsetHeight - chat.scrollTop - chat.offsetHeight < 3){
            chatSetRead()
          }
        }
    }

    if(chat.scrollHeight > chat.offsetHeight){
      chat.removeEventListener('scroll', scrollHandler);
      chat.addEventListener('scroll', scrollHandler)
    } else {
      chatSetRead()
    }
  }

  scrollTop() {
    const closest = (el, cls) => {
      while ( (el = el.parentElement) && !el.classList.contains(cls) );
      return el;
    }
    let chat = document.querySelector('#chat-list')
    if(chat){
      let msgs = chat.querySelectorAll('#message-item')
      let newMessage = chat.querySelector('#newMessage')
      const chatBlock = closest(chat, 'chatContent')
      if(newMessage){
        newMessage.scrollIntoView(false)
        this.listenToReadNewMessage(chatBlock, newMessage)
      } else {
        msgs[msgs.length -1].scrollIntoView()
      }
      chat.style.opacity = '1'
    }
  }

  renderChat(chatType){
    const {
      typeId,
      fetchChat,
      renderPublicChatAction,
      renderPrivateChatAction,
      renderTeamChatAction,
      privateChats,
      teamChats,
      publicChats
    } = this.props

    if (chatType === PUBLIC_CHAT_ID) {
      if(!publicChats.comments || !publicChats.comments.length) {
        fetchChat(PUBLIC_CHAT_ID, null)
      } else {
        renderPublicChatAction(publicChats.comments)
      }

    }
    if (chatType === PRIVATE_CHAT_ID) {
      if(!privateChats.comments || !privateChats.comments.length) {
        fetchChat(PRIVATE_CHAT_ID, null)
      } else {
        renderPrivateChatAction(privateChats.comments)
      }
    }
    if (chatType === TEAM_CHAT_ID) {
      if(!teamChats.comments || !teamChats.comments.length) {
        fetchChat(TEAM_CHAT_ID, null)
      } else {
        renderTeamChatAction(teamChats.comments)
      }
    }
    setTimeout(() => {
      this.scrollTop()
    }, 10)
  }


  changeChat(chatType) {
    const {
      typeId,
      clearRenderChat,
      changeChatType
    } = this.props

    //clearRenderChat()
    changeChatType(chatType)

    this.renderChat(chatType)
  }

  updateChatWs() {
    const {type, userId, fetchChat, admin, chatType} = this.props
    function getParameterByName(name, url) {
      if (!url) {
        url = window.location.href;
      }
      name = name.replace(/[\[\]]/g, "\\$&");
      let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(host + '/chat')
      .build();
    let arr = window.location.pathname.split('/')
    this.connection.on('Send', message => {
      console.log('messageeee')
      console.log(message)
      if (admin) {
        if(chatType === 1){
          fetchChat(chatType, null)
        }
      } else {
        if (message === 'update_private') {
          fetchChat(PRIVATE_CHAT_ID, null)
        }
        if (message === 'update_public') {
          fetchChat(PUBLIC_CHAT_ID, null)
        }
        if (message === 'update_team') {
          fetchChat(TEAM_CHAT_ID, null)
        }
      }
    });

    this.connection.start().then(()=> {
      return this.connection.invoke('ConnectUser', userId)
    }).catch(err => console.log(err));

 /*   this.connection.start()
      .then(() => connection.invoke("send", "Hello"));*/
  }

  componentDidMount() {
    const { role, chatType } = this.props
    const {miniChat, typeId, admin, fetchChat, changeChatType, clearRenderChat} = this.props

    const miniChatState = cookie.load('miniChatSmall') === undefined ? 1 : parseInt(cookie.load('miniChatSmall'))
    if(miniChatState){
      this.setState({
        miniChatSmall: true
      })
    } else {
      this.setState({
        miniChatSmall: false
      })
    }
    //clearRenderChat()
    if(!miniChat){
      setTimeout(() => {
        this.scrollTop()
      }, 10)
    }

    if (role === 2) {
      changeChatType(PUBLIC_CHAT_ID)
    }
   this.updateChatWs()
  }
  toggleMiniChat(bool){
    this.setState({
      miniChatOpen: bool
    })
  }
  render() {
    const {
      isForwarding,
      isMessageValid
    } = this.state

    const {
      isTaskChat,
      userId,
      publicChats,
      privateChats,
      teamChats,
      isWindow = true,
      isFetching,
      showAdminPanel = true,
      status,
      chatType,
      admin,
      renderPrivateChat,
      renderPublicChat,
      renderTeamChat,
      role,
      fetchChat,
      changeChatType,
      isFetchingChat,
      typeId,
      miniChat,
      userInfo,
      adminChatOpen
    } = this.props
    const idGroup = privateChats.id ? privateChats.id : 0

    const chat = <ChatBlock
      // Data
      userId={userId}
      role={role}
      messageChats={renderPrivateChat}
      commonChats={renderPublicChat}
      privateChats={renderPrivateChat}
      teamChats={renderTeamChat}
      unReadPublicChat={this.state.unReadPublicChat}
      unReadPrivateChat={this.state.unReadPrivateChat}
      unReadTeamChat={this.state.unReadTeamChat}
      admin={admin}
      typeId={typeId}
      toggleMiniChatSmall={this.toggleMiniChatSmall.bind(this)}
      toggleMiniChat={this.toggleMiniChat.bind(this)}
      miniChat={miniChat}
      userInfo={userInfo}
      isFetching={isFetching}
      miniChatSmall={this.state.miniChatSmall}
      miniChatOpen={this.state.miniChatOpen}
      isFetchingChat={isFetchingChat}
      chat={chatType}
      changeChat={this.changeChat.bind(this)}
      sendButtonText={isForwarding ? 'Переадресовать' : 'Ответить'}
      placeholderText={isForwarding ? 'Сообщение суперадмину' : 'Сообщение пользователю'}
      // Flags
      isForwarding={isForwarding}
      isMessageValid={isMessageValid}
      // Callbacks
      onMessageChanged={(e) => this.checkMessageLength(e)}
      onMessageSend={(message) => this.sendMessage(message)}
    />

    let style
    if (isWindow) {
      style = styles.chatWindow
    }  else if (isForwarding) {
      style = styles.chatForwarding
    }

    return adminChatOpen || !showAdminPanel ? (
      <div>
        {isTaskChat && <h2 className={styles.h1}>Чат</h2>}
        <div className={classnames(styles.chat, {[styles.chatMini]: miniChat })}>
          { showAdminPanel &&
          <svg
            onClick={() => this.closeChat()}
            className={styles.minionChatCloseIcon}>
            <use xlinkHref="#ico-close"></use>
          </svg>}

          {
            !isFetching && showAdminPanel && chatType === 2 ? (
                <div className={styles.chatAdminPanel}>
                  {
                    !isForwarding ? (
                        <button
                          onClick={() => this.waiting(idGroup)}
                          className={styles.chatAdminPanelBtnSecondary}>
                          Жду ответа
                        </button>
                      ) : null
                  }
                  <button
                    onClick={() => this.toggleForwarding()}
                    className={styles.chatAdminPanelBtnAction}>
                    {isForwarding ? 'Отмена' : 'Переадресовать'}
                  </button>
                  {status !== 2 &&
                    <button
                      onClick={() => this.answered(idGroup)}
                      className={styles.minionChatButtonForwardPrimary}>
                      Чат отвечен
                    </button>
                  }
                </div>
              ) : null
          }

          {chat}
        </div>
      </div>
    ) : null
  }
}
const mapStateToProps = state => {
  const {userInfo} = state

  const { publicChats,
        privateChats,
        teamChats,
        messageChats,
        isFetching,
        isFetchingChat,
        renderPrivateChat,
        renderPublicChat,
        renderTeamChat
    } = state.chat
  const chatsTest= state.chats
  const { adminChatOpen, groupId, chatTypeId, chatType, typeId} = state.chats
  return {
    publicChats,
    privateChats,
    teamChats,
    messageChats,
    renderPrivateChat,
    renderPublicChat,
    renderTeamChat,
    isFetching,
    chatsTest,
    adminChatOpen,
    groupId,
    typeId,
    chatType,
    chatTypeId,
    userInfo,
    isFetchingChat
  }
}
const mapDispatchToProps = dispatch => ({
  fetchChats: bindActionCreators(fetchChats, dispatch),
  fetchChat: bindActionCreators(fetchChat, dispatch),
  closeChat: bindActionCreators(closeChat, dispatch),
  addToChat: bindActionCreators(addToChat, dispatch),
  answerToChat: bindActionCreators(answerToChat, dispatch),
  answeredChat: bindActionCreators(answeredChat, dispatch),
  waitingFromChat: bindActionCreators(waitingFromChat, dispatch),
  concatPrivateChatAction: bindActionCreators(concatPrivateChatAction, dispatch),
  concatPublicChatAction: bindActionCreators(concatPublicChatAction, dispatch),
  concatTeamChatAction: bindActionCreators(concatTeamChatAction, dispatch),
  renderPublicChatAction: bindActionCreators(renderPublicChatAction, dispatch),
  renderPrivateChatAction: bindActionCreators(renderPrivateChatAction, dispatch),
  renderTeamChatAction: bindActionCreators(renderTeamChatAction, dispatch),
  changeStatusChatAction: bindActionCreators(changeStatusChatAction, dispatch),
  changeChatType: bindActionCreators(changeChatType, dispatch),
  setTypeId: bindActionCreators(setTypeId, dispatch),
  clearRenderChat: bindActionCreators(clearRenderChat, dispatch),
  changeChatComments: bindActionCreators(changeChatComments, dispatch),
  setUnReadComments: bindActionCreators(setUnReadComments, dispatch),
  setUnReadMsgs:bindActionCreators(setUnReadMsgs, dispatch),
  dispatch
})

Chat = connect(
  mapStateToProps,
  mapDispatchToProps
)(Chat)

export default CSSModules(Chat, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/containers/Chat.js